const observer = new IntersectionObserver(entries => {
entries.forEach(entry => {
    if (entry.isIntersecting) {
    entry.target.classList.add('inView');
    } else {
    entry.target.classList.remove('inView');
    }
});
}, {
threshold: 0.3 // Adjust as needed
});

document.querySelectorAll('.fadeUp').forEach(el => observer.observe(el));
